import { render, staticRenderFns } from "./myselfPrivacy.vue?vue&type=template&id=5bd84c28&scoped=true"
import script from "./myselfPrivacy.vue?vue&type=script&lang=js"
export * from "./myselfPrivacy.vue?vue&type=script&lang=js"
import style0 from "./myselfPrivacy.vue?vue&type=style&index=0&id=5bd84c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd84c28",
  null
  
)

export default component.exports